import './NotificationsPage.css'






import React from 'react'

const NotificationsPage = () => {
    return (
        <div>NotificationsPage</div>
    )
}

export default NotificationsPage